export const useFormState = ({ tab, waitConfirmScene, waitClaimScene, claimedScene }) => {
  const activeTab = tab ? tab.toUpperCase() : '';
  const tabContents = [
    {
      key: 'WAITCONFIRM',
      title: 'รอยืนยัน',
      count: 0,
      children: waitConfirmScene,
    },
    {
      key: 'WAITCLAIM',
      title: 'รอเคลม',
      count: 0,
      children: waitClaimScene,
    },
    {
      key: 'CLAIMED',
      title: 'เคลมแล้ว',
      count: 0,
      children: claimedScene,
    },
  ];

  const tabMap = new Map(tabContents?.map((item) => [item?.key, item]));
  const tabActive = tabMap?.get(activeTab) || tabContents[0];

  const tabCouponContents = [
    {
      key: 'SERVICE',
      title: 'บริการ',
    },
    {
      key: 'DISCOUNT',
      title: 'ส่วนลด',
    },
    {
      key: 'BIRTHDAY',
      title: 'วันเกิด',
    },
    {
      key: 'REDEEM',
      title: 'สมนาคุณ',
    },
  ];

  return {
    tabContents,
    tabActive,
    tabCouponContents,
  };
};
